<template>
  <div class="app-wrap">
    <rc-data-table
      ref="rcTable"
      :columns="columns"
      :replace-fields="listReplaceFields"
      :but="butData"
      :form="{
        form,
        data: formData,
        formItem
      }"
      :api="api"
      :dialog="dialog"
      :params="params"
    />
  </div>
</template>

<script>
import orgNew from "@/api/org/orgNew";
export default {
  name: "OrgGroup",
  data() {
    return {
      params: {
        "orders[0].asc": "false",
        "orders[0].column": "createTime"
      },
      columns: [
        {
          type: "index",
          label: "序号"
        },
        {
          label: "群名称",
          prop: "orgGroupName",
          type: "router",
          name: "orgGroupDetail",
          rowKey: "id"
        },
        {
          label: "主组织",
          prop: "orgFullName"
        },
        {
          label: "描述",
          prop: "description"
        }
      ],
      listReplaceFields: {
        pageNum: "page",
        pageSize: "size"
      },
      api: {
        model: orgNew,
        name: "page"
      },
      butData: {
        butData: [
          {
            label: "创建",
            prop: "add",
            type: "primary"
          }
        ],
        bottom16: true
      },
      form: {
        inline: true,
        closeLayout: true
      },
      formData: {
        search: ""
      },
      formItem: [
        {
          component: "rc-search",
          prop: "search",
          placeholder: "请输入组织群",
          span: 8
        }
      ],
      dialog: {
        title: "创建组织群",
        contentType: "form",
        imgIcon: "success",
        form: {
          hideRequiredAsterisk: true
        },
        data: {
          orgGroupName: "",
          mainOrgId: "",
          description: ""
        },
        formItem: [
          {
            component: "rc-input",
            label: "群名称",
            placeholder: "请输入名称",
            prop: "orgGroupName",
            span: 24,
            rules: { required: true, message: "请输入名称", trigger: ["change", "blur"] }
          },
          {
            component: "rc-select",
            label: "主组织",
            placeholder: "请选择主组织",
            prop: "mainOrgId",
            descLabel: "选择后不可更改，请谨慎选择",
            span: 24,
            width: 380,
            svgIcon: "hint",
            rules: { required: true, message: "请选择主组织", trigger: ["change", "blur"] },
            api: {
              model: orgNew,
              name: "all",
              params: {
                page: 1,
                size: 50,
                total: 0
              }
            },
            replaceFields: {
              value: "id",
              label: "orgName"
            },
            loadMore: true,
            slotStyle: {
              marginLeft: "8px",
              fontSize: "12px",
              color: "rgb(158, 165, 178)",
              fontWeight: "normal"
            },
            svgStyle: {
              fontSize: "18px",
              verticalAlign: "middle"
            }
          },
          {
            component: "rc-input",
            label: "描述",
            placeholder: "请输入内容",
            prop: "description",
            type: "textarea",
            autosize: {
              minRows: 3,
              maxRows: 3
            },
            slotStyle: {
              marginLeft: "8px",
              fontSize: "12px",
              color: "rgb(158, 165, 178)",
              fontWeight: "normal"
            },
            slotLabel: "选填",
            span: 24
          }
        ],
        apiConfirm: {
          model: orgNew,
          name: "group"
        }
      }
    };
  }
};
</script>
